import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ExcelService } from '../excel.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-combineloyalty-report',
  templateUrl: './combineloyalty-report.component.html',
  styleUrls: ['./combineloyalty-report.component.css']
})
export class CombineloyaltyReportComponent implements OnInit {
  redeemHistory: any[] = [];
  totalCount: number = 0;
  page: number = 1;
  pageSize: number = 10;
  fromDate: string;
  toDate: string;
  search: string = '';
  mobile: string = '';
  loading: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  show: boolean = false;
  reportExcelPassbook: any[] = [];
  modalRef: BsModalRef;
  displayedColumns: string[] = [];
  isUPIMode: boolean = false;


  formval: any = {
    Page: 1,
    PageSize: 10,
    fromdate: '',
    todate: '',
    SearchValue: ''
  };

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private excelService: ExcelService,
    private modalService: BsModalService
  ) { }

  getColumnHeader(column: string): string {
    if (column === 'amount' && !this.isUPIMode) {
      return 'Points';
    }
    const headers = {
      'UserName': 'User Name',
      'Mobile': 'Mobile',
      'payment_mode': 'Payment Mode',
      'Txnid': 'Transaction ID',
      'unique_request_number': 'Request Number',
      'unique_transaction_reference': 'Transaction Reference',
      'amount': 'Amount',
      'InRs': 'Amount (₹)',
      'beneficiary_account_name': 'Beneficiary Name',
      'beneficiary_upi_handle': 'UPI Handle',
      'transfer_date': 'Transfer Date',
      'Location': 'Location'
    };
    return headers[column] || column;
  }

  ngOnInit() {
    this.getRedeemHistory();
  }

  getRedeemHistory() {
    this.loading = true;

    const formattedFromDate = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : '';
    const formattedToDate = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : '';

    const requestData = {
      mobile: this.mobile,
      page: this.page,
      pageSize: this.pageSize,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      search: this.search
    };

    this.http.post<any>(environment.url + '/Report/GetRedeemHistory', requestData).subscribe(
      (response) => {
        console.log('API Response:', response);
        if (response.ResponseCode === 200) {
          this.redeemHistory = response.ResponseData || [];
          this.totalCount = response.ResponseData[0].TotalCount || 0;

          // Determine columns to display based on payment mode
          this.setDisplayedColumns();

          if (this.totalCount > 0 && !this.pageSizeOptions.includes(this.totalCount)) {
            this.pageSizeOptions = [...this.pageSizeOptions, this.totalCount].sort((a, b) => a - b);
          }
        }
        this.loading = false;
      },
      (error) => {
        console.error('API Error:', error);
        this.loading = false;
      }
    );
  }

  setDisplayedColumns() {
    if (this.redeemHistory.length > 0) {
      const firstItem = this.redeemHistory[0];
      this.isUPIMode = firstItem.payment_mode === 'UPI';

      if (this.isUPIMode) {
        this.displayedColumns = [
          'UserName',
          'Mobile',
          'payment_mode',
          'Txnid',
          'unique_request_number',
          'unique_transaction_reference',
          'amount',
          'beneficiary_account_name',
          'beneficiary_upi_handle',
          'transfer_date'
        ];
      } else {
        this.displayedColumns = [
          'UserName',
          'Mobile',
          'payment_mode',
          'amount',
          //'InRs',
          'transfer_date',
          'Location'
        ];
      }
    }
  }

  // ... rest of your existing methods ...


  pageChanged(event: PageChangedEvent): void {
    this.page = event.page;
    this.getRedeemHistory();
  }

  onPageSizeChange() {
    this.page = 1;
    this.getRedeemHistory();
  }

  exportToExcel() {
    this.show = true;

    // Determine if we're in UPI mode based on the first item (if available)
    const isUPIMode = this.redeemHistory.length > 0
      && this.redeemHistory[0].payment_mode === 'UPI';

    // Prepare the Excel data with appropriate columns
    const excelData = this.redeemHistory.map(item => {
      if (isUPIMode) {
        return {
          'User Name': item.UserName || '-',
          'Mobile': item.Mobile || '-',
          'Payment Mode': item.payment_mode || '-',
          'Transaction ID': item.Txnid || '-',
          'Request Number': item.unique_request_number || '-',
          'Transaction Reference': item.unique_transaction_reference || '-',
          'Amount (₹)': item.amount || '-',
          'Beneficiary Name': item.beneficiary_account_name || '-',
          'UPI Handle': item.beneficiary_upi_handle || '-',
          'Transfer Date': item.transfer_date ? this.formatDate(item.transfer_date) : '-'
        };
      } else {
        return {
          'User Name': item.UserName || '-',
          'Mobile': item.Mobile || '-',
          'Points': item.amount || '-',
          'Payment Mode': item.payment_mode || '-',
          'Transfer Date': item.transfer_date ? this.formatDate(item.transfer_date) : '-',
          'Location': item.Location || '-'
        };
      }
    });

    // Generate filename with date range if available
    let fileName = this.redeemHistory.length > 0 && this.redeemHistory[0].payment_mode === 'UPI'
      ? 'Dealer Redeemption history'
      : 'Contractor Redeemption history';
    if (this.fromDate && this.toDate) {
      const fromDateStr = moment(this.fromDate).format('DD-MMM-YYYY');
      const toDateStr = moment(this.toDate).format('DD-MMM-YYYY');
      fileName = `${fileName}_${fromDateStr}_to_${toDateStr}`;
    }

    // Add current timestamp to filename to avoid overwrites
    const timestamp = moment().format('YYYYMMDD_HHmmss');
    fileName = `${fileName}_${timestamp}`;

    // Export to Excel
    this.excelService.exportAsExcelFile(excelData, fileName);
    this.show = false;
  }

  // Helper method to format dates
  private formatDate(date: string | Date): string {
    return moment(date).format('DD-MMM-YYYY HH:mm');
  }

  // Helper method to format currency
  private formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount).replace('₹', '₹ ');
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg'
    });
  }
}